<template>
  <div class="edit-video-box">
    <el-dialog
      :title="'视频编辑'"
      :visible.sync="dialogVisible"
      width="960px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="editParam"
        :rules="rules"
        label-position="right"
        label-width="160px"
      >
        <div class="form-flex-box">
          <el-form-item label="视频标题:">
            <div class="flex">
              <el-input
                type="text"
                :rows="2"
                placeholder="请谨慎修改用户上传数据"
                v-model="editParam.title"
                :disabled="editTitle"
              ></el-input>
              <el-button
                type="success"
                size="small"
                class="ml-5"
                @click="editTitle = false"
                >修改
              </el-button>
            </div>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="主题模块:" prop="subModuleID">
            <div style="height: 32px">
              <el-cascader
                :options="secondModuleList"
                style="width: 100%"
                v-model="editParam.subModuleID"
                :show-all-levels="false"
                :props="{ emitPath: false, expandTrigger: 'hover' }"
                @change="handleChangeModule"
                clearable
              ></el-cascader>
            </div>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="封面上传:" prop="cover">
            <base-upload
              :cover="editParam.cover"
              :action="action"
              :key="editParam.cover"
              @successCallback="successCallback"
              :id="sourceID"
              :wSize="180"
              :hSize="200"
              :width="'220px'"
            ></base-upload>
            <div class="mt-10 flex">
              <span>封面地址：</span>
              <div class="flex1">
                <el-input
                  v-model="editParam.cover"
                  size="small"
                  placeholder="此图文地址可以复制到其他产品中或者从其他产品复制到此处，可以避免重复上传直接共用"
                ></el-input>
              </div>
            </div>
            <div class="mt-10 flex">
              <span>视频地址：</span>
              <div class="flex1">
                <el-input
                  v-model="editParam.sourceURL"
                  size="small"
                  placeholder="此视频地址可以复制到其他产品中或者从其他产品复制到此处，可以避免重复上传直接共用"
                ></el-input>
              </div>
            </div>
            <div class="mt-10 flex">
              <span>备份地址：</span>
              <div class="flex1">
                <el-input
                  v-model="editParam.bsourceURL"
                  size="small"
                  placeholder="此视频地址用于清空视频的备份，可以把视频地址或者图片地址复制到此处，后续到底还原的目的，防止误操作"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="视频起始位置（秒）:" prop="cposition">
            <div class="flex">
              <el-input
                v-model.number="editParam.cposition"
                size="small"
              ></el-input>
              <div style="width: 200px" class="ml-10 fz12">
                转换后：{{ formatTime(editParam.cposition) }}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="视频时长:（秒）" prop="sortCode">
            <div class="flex just-between">
              <el-input
                v-model.number="editParam.playTime"
                size="small"
              ></el-input>
              <div style="width: 200px" class="ml-10 fz12">
                转换后：{{ formatTime(editParam.playTime) }}
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="价格:" prop="coins">
            <el-input
              v-model.number="editParam.coins"
              size="small"
              placeholder="请输入价格"
            ></el-input>
          </el-form-item>
          <el-form-item label="免费时长:" prop="freeTime">
            <el-input
              v-model.number="editParam.freeTime"
              size="small"
              placeholder="请输入视频免费时长"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否可推荐:" prop="recoWeight" v-if="false">
            <el-select
              v-model.number="editParam.recoWeight"
              placeholder="请选择可否推荐"
              size="small"
            >
              <el-option label="可推荐" :value="0"></el-option>
              <el-option label="不可推荐" :value="-1"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="审核状态:" prop="status">
            <el-select
              v-model.number="editParam.status"
              placeholder="请选择审核状态"
              size="small"
            >
              <el-option label="通过" :value="1"></el-option>
              <el-option label="未通过" :value="2"></el-option>
              <el-option label="下架" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分享数(假):" prop="fakeShareCount">
            <el-input
              v-model.number="editParam.fakeShareCount"
              size="small"
              placeholder="请输入假分享数"
            ></el-input>
          </el-form-item>
          <el-form-item label="打赏金额(假):" prop="fakeRewarded">
            <el-input
              v-model.number="editParam.fakeRewarded"
              size="small"
              placeholder="请输入假打赏金额"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="广告排序号:" prop="sortCode">
            <el-input
              v-model.number="editParam.sortCode"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="作品排序号:" prop="worksSort">
            <el-input
              v-model.number="editParam.worksSort"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="置顶排序号:" prop="liaoBaTopSort">
            <el-input
              v-model.number="editParam.liaoBaTopSort"
              size="small"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="用户ID:" prop="publisherID">
            <el-input
              v-model.number="editParam.publisherID"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="跳转连接:" prop="linkUrl">
            <el-input
              v-if="showCustomLinkUrlInput"
              type="textarea"
              v-model="editParam.linkUrl"
              size="small"
              placeholder="请输入黄游跳转链接"
            ></el-input>
            <el-select
              v-else
              v-model="selectedLinkUrlType"
              clearable
              placeholder="请选择跳转连接"
              @change="handleLinkUrlTypeChange"
            >
              <el-option label="请选择" value=""></el-option>
              <el-option
                v-for="(item, index) in JUMPLIST()"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button
              v-if="showCustomLinkUrlInput"
              type="text"
              class="mt-5"
              @click="resetLinkUrlType"
            >
              返回选择
            </el-button>
          </el-form-item>
          <el-form-item label="标签:" prop="tags">
            <el-input v-model="editParam.tags" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <div class="none">
            <el-form-item label="排序号:" prop="sortCode">
              <el-input
                v-model.number="editParam.sortCode"
                size="small"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item label="标签:" prop="tags">
            <tag-selector
              v-model="editParam.tags"
              :tagList="tagList"
            ></tag-selector>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="点赞数(用于排序):" prop="likeCount">
            <el-input
              v-model.number="editParam.likeCount"
              max="1"
              size="small"
              placeholder="请输入真播放数"
            ></el-input>
            <div>最大参考值：{{ maxLikeCount }}</div>
            <div>用于：app搜索处理的精彩推荐</div>
          </el-form-item>
          <el-form-item label="播放数(用于排序):" prop="playCount">
            <el-input
              v-model.number="editParam.playCount"
              max="1"
              size="small"
              placeholder="请输入真播放数"
            ></el-input>
            <div>最大参考值：{{ maxPlayCount }}</div>
            <div>用于：app搜索处理的热搜推荐、最多观看</div>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="点赞数(用于显示):" prop="fakeLikeCount">
            <el-input
              v-model.number="editParam.fakeLikeCount"
              size="small"
              placeholder="请输入假点赞数"
            ></el-input>
            <p class="red fz12">
              总点赞量 = 假点赞量 * 33 ({{
                formatNumber(editParam.fakeLikeCount * 33)
              }})
            </p>
          </el-form-item>
          <el-form-item label="播放数(用于显示):" prop="fakePlayCount">
            <el-input
              v-model.number="editParam.fakePlayCount"
              max="1"
              size="small"
              placeholder="请输入假播放数"
            ></el-input>
            <p class="red fz12">
              播放总播放量 = 假播放量 * 17 ({{
                formatNumber(editParam.fakePlayCount * 17)
              }})
            </p>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitDate()"
          :loading="flag"
          >确 认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import {
  validatorIndex,
  validatorLiaoBaTopSort,
  validatorOver3,
  validatorWorksSort,
} from "@/utils/validator";
import API from "@/api";
import TagSelector from "@/components/tagSelector";
import { JUMPLIST as JUMP_LINK_LIST } from "@/utils/constants";

const HUANGYOU_LINK_VALUE = "yinseinner://huangyou";

export default {
  components: {
    TagSelector,
  },
  data() {
    return {
      dialogVisible: false,
      flag: false,
      isEdit: true,
      secondModuleList: [], // 二级模块列表
      maxPlayCount: 0,
      maxLikeCount: 0,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      tagList: [], //标签列表：包含标签名称和标签id
      sourceID: "",
      editTitle: true,
      showCustomLinkUrlInput: false,
      selectedLinkUrlType: "",
      editParam: {
        id: "",
        publisherID: "",
        tags: [],
        subModuleID: "",
        sourceURL: "",
        bsourceURL: "",
        tagSort: [],
        cover: "",
        coverThumb: "",
        title: "",
        status: "",
        fakeLikeCount: 1,
        fakePlayCount: 1,
        fakeShareCount: 1,
        fakeRewarded: 1,
        likeCount: 0,
        playCount: 0,
        shareCount: 0,
        freeTime: 15,
        coins: 0,
        cposition: 0,
        playTime: "",
        linkUrl: "",
        sortCode: "",
        type: 0,
        worksSort: "",
        liaoBaTopSort: "",
      },
      // 表单验证规则
      rules: {
        cover: [
          { required: true, message: "请输入添加封面图片", trigger: "blur" },
        ],
        fakeLikeCount: [
          { required: true, message: "请输入假点赞数", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
          { validator: this.validatorLike, trigger: "blur" },
        ],
        fakePlayCount: [
          { required: true, message: "请输入假播放数", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
          { validator: this.validatorPlayer, trigger: "blur" },
        ],
        fakeShareCount: [
          { required: true, message: "请输入假共享数", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
          { validator: this.validatorShare, trigger: "blur" },
        ],
        fakeRewarded: [{ validator: validatorIndex, trigger: "blur" }],
        freeTime: [
          { required: true, message: "请输入免费时长", trigger: "blur" },
          { validator: validatorOver3, trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        tags: [{ required: true, message: "请选择标签", trigger: "blur" }],
        coins: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        worksSort: [{ validator: validatorWorksSort, trigger: "blur" }],
        liaoBaTopSort: [{ validator: validatorLiaoBaTopSort, trigger: "blur" }],
      },
    };
  },
  methods: {
    JUMPLIST() {
      return JUMP_LINK_LIST;
    },
    isPresetLinkUrl(linkUrl) {
      return JUMP_LINK_LIST.some((item) => item.value === linkUrl);
    },
    syncLinkUrlType(linkUrl) {
      if (linkUrl === HUANGYOU_LINK_VALUE) {
        this.showCustomLinkUrlInput = true;
        this.selectedLinkUrlType = HUANGYOU_LINK_VALUE;
        this.editParam.linkUrl = "";
        return;
      }
      if (linkUrl && !this.isPresetLinkUrl(linkUrl)) {
        this.showCustomLinkUrlInput = true;
        this.selectedLinkUrlType = HUANGYOU_LINK_VALUE;
        return;
      }
      this.showCustomLinkUrlInput = false;
      this.selectedLinkUrlType = linkUrl || "";
    },
    handleLinkUrlTypeChange(val) {
      if (val === HUANGYOU_LINK_VALUE) {
        this.showCustomLinkUrlInput = true;
        this.editParam.linkUrl = "";
        return;
      }
      this.showCustomLinkUrlInput = false;
      this.editParam.linkUrl = val || "";
    },
    resetLinkUrlType() {
      this.showCustomLinkUrlInput = false;
      this.selectedLinkUrlType = "";
      this.editParam.linkUrl = "";
    },
    formatNumber(num) {
      if (num >= 1e8) {
        // 转换为以 "亿" 为单位
        return (num / 1e8).toFixed(2).replace(/\.00$/, "") + "亿";
      } else if (num >= 1e4) {
        // 转换为以 "万" 为单位
        return (num / 1e4).toFixed(2).replace(/\.00$/, "") + "w";
      } else if (num >= 1e3) {
        // 转换为以 "千" 为单位
        return (num / 1e3).toFixed(2).replace(/\.00$/, "") + "k";
      } else {
        if (!num) {
          return "0";
        }
        // 保持原样
        return num.toString();
      }
    },

    getTagList() {
      const params = {};
      API.queryTagList(params).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data.list;
        }
      });
    },
    // 提交验证
    submitDate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          const tags = this.editParam.tags.filter(
            (item) => this.tagList.map((e) => e.name).indexOf(item) === -1,
          );
          if (tags.length > 0) {
            this.$confirm(
              `标签${tags.join(",")}不属于常用标签，确定修改？`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              },
            )
              .then(() => {
                this.editVideo();
              })
              .catch(() => {
                this.flag = false;
                return false;
              });
          } else {
            this.editVideo();
          }
        } else {
          this.flag = false;
          return false;
        }
      });
    },
    // 编辑
    editVideo() {
      API.editVideoInfo(this.editParam)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.$emit("handlerVideoList");
          } else {
            this.$message.error("编辑失败！");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    getHotModule() {
      const params = {
        pageSize: 20,
        pageNumber: 1,
      };
      API.getModuleList(params).then((res) => {
        this.secondModuleList = this.transformData(res.data);
      });
    },
    getPlayLikeMax() {
      const params = {};
      API.getPlayLikeMax(params).then((res) => {
        if (res.code === 200) {
          this.maxLikeCount = res.data.likecountmax;
          this.maxPlayCount = res.data.playcountmax;
        }
      });
    },
    transformData(originalData) {
      return originalData.map((module) => {
        return {
          value: module.moduleID,
          label: module.moduleName,
          children: module.list
            ? module.list.map((subModule) => {
                return {
                  value: subModule.moduleID,
                  label: subModule.moduleName,
                  children: subModule.subModules
                    ? subModule.subModules.map((item) => {
                        return {
                          value: item.id,
                          label: item.moduleName,
                        };
                      })
                    : null,
                };
              })
            : null,
        };
      });
    },
    handleChangeModule(val) {
      this.editParam.subModuleID = val;
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.editParam.cover = res.data.coverImg;
      this.editParam.coverThumb = res.data.coverImg;
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.getTagList();
      this.getHotModule();
      this.getPlayLikeMax();
      this.dialogVisible = true;
      this.editParam.id = data.id;
      this.isEdit = data.status === 2 ? false : true;
      this.editParam.status = data.status;
      this.editParam.cover = data.cover;
      this.editParam.sourceURL = data.sourceURL;
      this.editParam.bsourceURL = data.bsourceURL;
      this.editParam.publisherID = data.uid;
      this.editParam.title = data.title;
      this.editParam.coverThumb = data.coverThumb;
      this.editParam.fakeLikeCount = data.fakeLikeCount || 1;
      this.editParam.fakePlayCount = data.fakePlayCount || 1;
      this.editParam.fakeShareCount = data.fakeShareCount;
      this.editParam.fakeRewarded = Number(data.fakeRewarded);
      this.editParam.likeCount = data.likeCount;
      this.editParam.playCount = data.playCount;
      this.editParam.shareCount = data.shareCount;
      this.editParam.freeTime = data.freeTime > 2 ? data.freeTime : 3;
      this.editParam.isChosen = data.chosen;
      this.editParam.coins = data.coins;
      this.editParam.subModuleID = data.subModuleID;
      this.editParam.recoWeight = data.recoWeight;
      this.editParam.linkUrl = data.linkUrl;
      this.syncLinkUrlType(data.linkUrl);
      this.editParam.cposition = data.cposition;
      this.editParam.playTime = data.playTime;
      this.editParam.sortCode = data.sortCode;
      this.editParam.worksSort = data.worksSort;
      this.editParam.liaoBaTopSort = data.liaoBaTopSort;
      this.sourceID = data.sourceID;
      this.editParam.tags = data.tags ? data.tags.map((item) => item.name) : [];
      this.editParam.tagSort = data.tagSort ? data.tagSort : [];
    },

    formatTime(seconds) {
      if (!seconds) return "00:00";
      // 计算小时、分钟和秒
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      // 根据小时、分钟、秒的值来构建时间字符串
      let timeString = "";

      if (hours > 0) {
        timeString += `${hours}:`;
      }

      if (minutes > 0 || hours > 0) {
        timeString += `${minutes.toString().padStart(2, "0")}:`;
      } else if (hours > 0) {
        // 如果没有分钟，直接显示秒数
        timeString += `${minutes.toString().padStart(2, "0")}:`;
      }
      timeString += secs.toString().padStart(2, "0");
      return timeString;
    },

    // 关闭回掉
    handleClose() {
      this.dialogVisible = false;
      this.isEdit = true;
      this.editTitle = true;
      this.showCustomLinkUrlInput = false;
      this.selectedLinkUrlType = "";
      this.$refs.form.resetFields();
    },
    // 验证播放数
    validatorPlayer(rule, value, callback) {
      //if (value >= this.editParam.playCount) {
      callback();
      // } else {
      //   callback(
      //       new Error(
      //           "假播放数必须大于或者等于真播放数（当前真播放数为:" +
      //           this.editParam.playCount +
      //           "）"
      //       )
      //   );
      // }
    },
    // 验证点赞数
    validatorLike(rule, value, callback) {
      //if (value >= this.editParam.likeCount) {
      callback();
      // } else {
      //   callback(
      //       new Error(
      //           "假点赞数必须大于或者等于真点赞数（当前真点赞数为:" +
      //           this.editParam.likeCount +
      //           "）"
      //       )
      //   );
      // }
    },
    // 验证点赞数
    validatorShare(rule, value, callback) {
      //if (value >= this.editParam.shareCount) {
      callback();
      // } else {
      //   callback(
      //       new Error(
      //           "假共享数必须大于或者等于真共享数（当前真共享数为:" +
      //           this.editParam.shareCount +
      //           "）"
      //       )
      //   );
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100% !important;
  }

  .form-flex-box {
    display: flex;

    .el-form-item {
      flex: 1;
      margin-bottom: 12px !important;
    }
  }
}
</style>
